module.exports = __webpack_public_path__ + "img/section_card2.632a555a.png";